import useQueryDataListener from './useQueryDataListener';

export default useQueryDataListener;
